// BoothMapLegend Component (Issue #676)
// Displays legend for booth map colors, symbols, and amenities

import React from 'react';

interface LegendItem {
  label: string;
  color: string;
  icon?: string;
}

const BoothMapLegend: React.FC = () => {
  const boothStatusItems: LegendItem[] = [
    { label: 'Available', color: '#10B981' },
    { label: 'Reserved', color: '#EF4444' },
    { label: 'Corner Booth', color: '#F59E0B' },
    { label: 'High Traffic', color: '#8B5CF6' },
    { label: 'Near Entrance', color: '#06B6D4' },
  ];

  const amenityItems: LegendItem[] = [
    { label: 'Entrance', color: '#10B981', icon: '🚪' },
    { label: 'Restrooms', color: '#3B82F6', icon: '🚻' },
    { label: 'Food Court', color: '#F59E0B', icon: '🍴' },
    { label: 'Parking', color: '#6366F1', icon: '🅿️' },
    { label: 'Stage', color: '#EC4899', icon: '🎭' },
    { label: 'Water', color: '#06B6D4', icon: '💧' },
  ];

  return (
    <div className="booth-map-legend bg-white rounded-lg shadow-md p-4 space-y-4">
      {/* Booth Status Section */}
      <div>
        <h3 className="text-sm font-semibold text-gray-700 mb-2">Booth Status</h3>
        <div className="space-y-2">
          {boothStatusItems.map((item) => (
            <div key={item.label} className="flex items-center gap-2">
              <div
                className="w-4 h-4 rounded"
                style={{ backgroundColor: item.color }}
              />
              <span className="text-xs text-gray-600">{item.label}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Amenities Section */}
      <div>
        <h3 className="text-sm font-semibold text-gray-700 mb-2">Amenities</h3>
        <div className="space-y-2">
          {amenityItems.map((item) => (
            <div key={item.label} className="flex items-center gap-2">
              <div
                className="w-6 h-6 rounded-full flex items-center justify-center text-sm"
                style={{ backgroundColor: item.color }}
              >
                {item.icon}
              </div>
              <span className="text-xs text-gray-600">{item.label}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Map Controls Info */}
      <div className="border-t pt-3">
        <h3 className="text-sm font-semibold text-gray-700 mb-2">Map Controls</h3>
        <div className="space-y-1 text-xs text-gray-600">
          <p><strong>Desktop:</strong></p>
          <p>• Click booth for details</p>
          <p>• Scroll to zoom</p>
          <p>• Drag to pan</p>
          <p className="pt-2"><strong>Mobile:</strong></p>
          <p>• Tap booth for details</p>
          <p>• Tap-and-hold (500ms) for info</p>
          <p>• Pinch to zoom</p>
          <p>• Two-finger pan</p>
          <p>• Double-tap to zoom in</p>
          <p>• Swipe up/down to show/hide legend</p>
          <p className="pt-2"><strong>Keyboard:</strong></p>
          <p>• +/- to zoom in/out</p>
          <p>• Arrow keys to pan</p>
          <p>• R to reset view</p>
          <p>• L to toggle legend</p>
        </div>
      </div>
    </div>
  );
};

export default BoothMapLegend;
